<template>
  <van-popup
    class="mob_dialog"
    v-model="visible"
    round
    closeable
    close-icon="cross"
    position="bottom"
    @close="handleClose"
    :style="{ height: 'auto', color: '#000' }"
  >
    <van-form @submit="onSubmit" ref="form" class="dialog-form">
      <h2>{{ title }}</h2>
      <van-field
        v-model="form.username"
        clearable
        name="username"
        placeholder="联系人（必填）"
        :rules="[{ required: true, message: '请填写联系人' }]"
      />
      <van-field
        v-model="form.tel"
        clearable
        name="tel"
        type="tel"
        placeholder="手机号（必填）"
        :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <van-field v-model="form.company" clearable placeholder="公司名称" />
      <van-field v-model="form.direct" clearable placeholder="合作方向" />
      <van-field v-model="form.email" clearable placeholder="电子邮箱" />

      <van-button block type="info" native-type="submit">提交</van-button>
    </van-form>
  </van-popup>
</template>

<script>
import {validatePhone,validateEMail,validate20Chart} from '@/utils/utils'
export default {
  props: {
    systemId: {
      type: String,
      default: '1',
    },
    title: {
      type: String,
      default: '申请成为合作伙伴',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(ev) {
      this.visible = ev
    },
  },
  data() {
    return {
      visible: false,
      form: {
        username: '',
        tel: '',
        company: '',
        direct: '',
        email: '',
      },
    }
  },
  methods: {
    onSubmit(values) {
      console.log('values', values)
      if (values) {
        if (! validate20Chart(this.form.username)) {
        this.$message.warning('请填写正确的联系人姓名')
        return
      }
      if (! validatePhone(this.form.tel)) {
        this.$message.warning('请填写正确的联系人手机号')
        return
      }
      if(this.form.company.length > 30) {
        this.$message.warning("公司名称太长");
        return
      }
      if(this.form.direct.length > 30) {
        this.$message.warning("合作方向太长");
        return
      }
      if(! validateEMail(this.form.email)) {
        this.$message.warning("请填写正确的联系邮箱");
        return
      }
        let strTemp = ''
        for (let key in Object.values(values)) {
          //if (values.hasOwnProperty(key)) {
          strTemp += key + '_'
          //}
        }
        strTemp = strTemp.substring(0, strTemp.length - 1)
        this.$store
          .dispatch('api/informationsAdd', {
            informations: strTemp,
            system_id: this.systemId || '1',
          })
          .then((response) => {
            if (response.code == 0) {
              this.$toast('提交成功')
              this.handleClose()
            }
          })
      }
    },
    handleClose() {
      this.$refs['form'].resetValidation()
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.mob_dialog {
  .van-field__error-message {
    display: none !important;
  }
  &.van-popup--bottom.van-popup--round {
    border-radius: 0.15rem 0.15rem 0 0;
    .van-popup__close-icon {
      color: #000;
    }
  }
  .dialog-form {
    display: block;
    padding: 0.6rem;
    h2 {
      margin: 0;
      height: 0.36rem;
      line-height: 0.36rem;
      font-size: 0.32rem;
      color: #333;
      text-align: center;
      margin-bottom: 0.27rem;
      font-weight: normal;
    }
    .van-cell {
      height: 0.91rem;
      padding-top: 0.32rem;
    }
    .van-button {
      margin-top: 0.5rem;
      margin-bottom: 0.2rem;
    }
  }
}
</style>
